import { IonContent } from '@ionic/react';
import React from 'react';

import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { AI_DATA } from '@/pages/Onboarding/constants';
import { useOnboarding } from '@/pages/Onboarding/context';
import { canLogEvents } from '@/utils/canLogEvents';

import './ChatVibe.scss';

export const OnboardingReplikaChatVibe: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Chat Vibe',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <OnboardingPage
      className="onboarding-no-limits"
      bgImage={
        <img
          src={AI_DATA[webCampaign.aiType].chatVibe.bgImageSrc}
          alt="Chat Vibe"
        />
      }
    >
      <IonContent>
        <OnboardingTitle color="black">Perfect chat vibe</OnboardingTitle>
        <OnboardingSubtitle
          color="neutral-black"
          className="onboarding-no-limits__subtitle"
        >
          Each character brings their own unique style, designed to brighten
          your day and keep you feeling engaged
        </OnboardingSubtitle>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} />
    </OnboardingPage>
  );
};
